import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { IState } from '../../../../store/types'
import { IShowStateProps, IShowDispatchProps } from './types'
import { fetchPlans, deletePlan } from '../../../../store/plans/actions'
import { fetchDrugs } from '../../../../store/drugs/actions'
import { Show } from './Show'
import { IPlan } from '../../../../types/plan'

const mapStateToProps = (state: IState): IShowStateProps => {
  return {
    drugs: state.drugs,
    plans: state.plans,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IShowDispatchProps => {
  return {
    fetchDrugs: () => dispatch(fetchDrugs()),
    fetchPlans: () => dispatch(fetchPlans()),
    deletePlan: (plan: IPlan) => dispatch(deletePlan(plan))
  }
}

const ShowContainer = connect(mapStateToProps, mapDispatchToProps)(Show)

export {
  ShowContainer
}
